module.exports = __webpack_public_path__ + "img/home-bg.54f989d7.png";